import { render, staticRenderFns } from "./gateinpending.vue?vue&type=template&id=f1d4ee2e&scoped=true&"
import script from "./gateinpending.vue?vue&type=script&lang=js&"
export * from "./gateinpending.vue?vue&type=script&lang=js&"
import style0 from "./gateinpending.vue?vue&type=style&index=0&id=f1d4ee2e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d4ee2e",
  null
  
)

export default component.exports